import { useAuth } from "../../context/auth-context";
import type {
  AdminBusinessSummaryData,
  AdminBusinessSummaryEnvelope,
} from "./adminBusinessSummary";
import { apiQueryKey } from "./queryKeys";
import { useApiQuery } from "./useApiQuery";

export type UseAdminBusinessSummaryParams = {
  /** Inclusive range, YYYY-MM-DD. Omit both for all-time totals. */
  from?: string;
  to?: string;
  businessId?: string;
  enabled?: boolean;
};

/**
 * GET api/businesses/admin/summary[?from][&to][&businessId]
 */
export function useAdminBusinessSummaryQuery(
  params: UseAdminBusinessSummaryParams = {}
) {
  const { isAuthenticated } = useAuth();
  const { from, to, businessId, enabled: enabledParam = true } = params;

  return useApiQuery<AdminBusinessSummaryEnvelope, AdminBusinessSummaryData>({
    queryKey: apiQueryKey("business-summary", {
      from: from ?? null,
      to: to ?? null,
      businessId: businessId ?? null,
    }),
    url: "api/businesses/admin/summary",
    params: {
      from,
      to,
      businessId,
    },
    enabled: Boolean(isAuthenticated) && enabledParam,
    select: (body) => body.data,
  });
}
